const text = value => String(value ?? '').trim()
/** Read-only family evidence. Exact unique-name matching is not a durable relationship. */
export function splitParentSummary(record) {
  const c=record||{}, family=c.splitFamily
  const isParent=family?.role==='parent'||text(c.championSearchTag??c.sr_champion_search??c.raw?.sr_champion_search)==='split_into_divisions'
  if(!isParent)return null
  const fixes=Array.isArray(family?.fixes)?family.fixes:[]
  const ambiguous=fixes.some(f=>f.key==='ambiguous_parent')
  const entries=[...(family?.teams||[]),...(family?.indy?.members||[]).map(id=>({id,label:'Individual winner record'}))]
  const ids=entries.map(e=>text(e.id))
  const matched=family?.relationshipBasis==='exact_unique_name'&&!ambiguous&&ids.every(id=>id&&id!==text(c.id)&&!id.startsWith('indy:'))&&new Set(ids).size===ids.length
  const children=matched?entries.map(e=>({id:text(e.id),label:text(e.label)||'Matched child record',champion:text(e.champion)})):[]
  const complete=matched&&children.length>0&&fixes.length===0
  return {isParent:true,complete,children,
    headline:complete?'Split results recorded on matched children':'Split reconciliation needed',
    note:'Name-based matching only; this is not a verified durable parent-child relationship. The parent is a container, not a separate crown.',
    reasons:fixes.length?fixes.map(f=>text(f.reason)).filter(Boolean):complete?[]:['No unambiguous complete child set is established in this read.'],
  }
}
